import { apiGet } from "../../../utils"

export function getDataByCumulativeSearchAPI(data) {
    return apiGet(`/api/v1/getDataByCumulativeSearch`, data)
}

export function getEmailsByVesselAPI(data) {
    return apiGet(`/api/v1/getEmailsByVessel`, data)
}